import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Orders.css";

const Orders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
          navigate("/login");
          return;
        }
        const response = await fetch(`https://kothari-international-server.onrender.com/api/orders/${user.id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch orders");
        }
        const data = await response.json();
        setOrders(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching orders:", error);
        setLoading(false);
      }
    };
    fetchOrders();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;
  if (orders.length === 0) return <p>No orders found.</p>;

  return (
    <div className="orders">
      <h1>Your Orders</h1>
      {orders.map((order) => (
        <div key={order.id} className="order">
          <h2>Order ID: {order.order_id}</h2>
          <p><strong>Payment Method:</strong> {order.payment_method}</p>
          {order.razorpay_payment_id && (
            <p><strong>Transaction ID:</strong> {order.razorpay_payment_id}</p>
          )}
          <p><strong>Total Amount:</strong> ₹{order.total_amount}</p>
          <h3>Items:</h3>
          {order.items.map((item) => (
            <div key={item.id} className="order-item">
              <img src={item.image} alt={item.name} />
              <div>
                <h4>{item.name}</h4>
                <p>₹{item.price} x {item.quantity}</p>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Orders;